import {callApi} from '@/shared/ApiHelper'
import dayjs from 'dayjs'
import {setStartAndEndDates} from '@/shared/Utilities'
import {showFacilitatorGuide, storeRegistrationByEventIdAndAttendeeId} from '@/shared/ApiHelper'

export const checkForAppReload = async function(route, event, apiStore) {
    let reloaded = apiStore.isNewInstance
    if (reloaded) {
        console.log('App reload: recalculating state')
    }
    
    if (false == event.isCached) {
        apiStore.mySchedule = null // Remove any cached personal schedule from other events
        console.log('Cached personal schedule removed, if present')
    }
    if (apiStore.isNewInstance || false == event.isCached) {
        await setNavigationVisibility(event, apiStore)
        apiStore.isNewInstance = false
    }

    return reloaded
}

export const getEventWaitList = async function(eventId, format, apiStore) {
    const apiResponse = await callApi(apiStore.buildUrl('/events/waitlists/?event=' + eventId))
    if (apiResponse && 200 == apiResponse.status && apiResponse.data && Array.isArray(apiResponse.data)) {
        for (let i in apiResponse.data) {
            if (format == apiResponse.data[i].format) {
                return apiResponse.data[i]
            }
        }
    }

    return null
}

export const isEventFormatFull = function(format, apiStore) {
    let isFull = false
    for (let i in apiStore.currentEvent.sessions) {
        const session = apiStore.currentEvent.sessions[i]
        if ('in person' == format) {
            const attendeesCount = session.in_person_attendees_count
            if (session.attendance_limit_in_person != 0 && attendeesCount >= session.attendance_limit_in_person) {
                isFull = true
                break
            }
        }
        if ('virtual' == format) {
            const attendeesCount = session.virtual_attendees_count
            if (session.attendance_limit_virtual != 0 && attendeesCount >= session.attendance_limit_virtual) {
                isFull = true
                break
            }
        }
    }

    return isFull
}

export const resetApiStore = function(route, apiStore) {
    if (route.query.signout && 'true' == route.query.signout) {
        apiStore.currentAttendee = null
        apiStore.currentEvent = null
        apiStore.currentPresenter = null
        apiStore.displayName = null
        apiStore.events = null
        apiStore.facilitatorGuide = false
        apiStore.isAdmin = false
        apiStore.isStaff = false
        apiStore.mySchedule = null
        apiStore.pastEvents = null
        apiStore.presenters = null
        apiStore.topPastEvents = null
        console.log('apiStore cleared')

        window.location = '/'
    }
}

export const setAllowScheduleChanges = async function(apiStore) {
    apiStore.allowScheduleChanges = false
    if (apiStore.currentAttendee && apiStore.currentEvent) {
        const today = dayjs()
        if (apiStore.isRegisteredForCurrentEvent) { // If registered...
            setStartAndEndDates([apiStore.currentEvent.event])
            const eventStartDate = dayjs(apiStore.currentEvent.event.start_date).startOf('day')
            const eventEndDate = dayjs(apiStore.currentEvent.event.end_date).endOf('day')
            const endEvaluation = eventEndDate.add(apiStore.currentEvent.event.days_evaluation_is_open_after_event_ends, 'days')
            if (today.isBefore(endEvaluation)) { // ...and before evaluation period ends...
                if (null == apiStore.currentRegistration) {
                    await storeRegistrationByEventIdAndAttendeeId(apiStore.currentEvent.event.id, apiStore.currentAttendee.id)
                }
                if (apiStore.currentRegistration && // ...and activity not complete (or event hasn't started yet)
                    (today.isBefore(eventStartDate) ||
                     false == apiStore.currentRegistration.actions_completed)) {
                    apiStore.allowScheduleChanges = true
                }
            }
        }
    }
}

export const setNavigationVisibility = async function(event, apiStore) {
    apiStore.navigationVisibilities.isVisibilitySet = false
    apiStore.navigationVisibilities.showCreditLink = false
    apiStore.navigationVisibilities.showFacilitatorGuideLink = false
    apiStore.navigationVisibilities.showExhibitorsLink = false
    apiStore.navigationVisibilities.showMaterialsLink = false
    apiStore.navigationVisibilities.showMyScheduleLink = false
    apiStore.navigationVisibilities.showPartnersLink = false
    apiStore.navigationVisibilities.showPresentersLink = false
    apiStore.navigationVisibilities.showScheduleLink = false
    apiStore.navigationVisibilities.showSponsorsLink = false
    apiStore.navigationVisibilities.showVenuesLink = false
    apiStore.navigationVisibilities.showPosterLink = false

    apiStore.navigationVisibilities.showCreditLink =
        (null != event.credit && '' != event.credit) ||
        (null != event.asha_level && '' != event.asha_level && null != event.asha_ceus && '' != event.asha_ceus)
    apiStore.navigationVisibilities.showFacilitatorGuideLink = showFacilitatorGuide()
    let response = await callApi(apiStore.buildUrl('/events/event_has_external_entities/' + event.id + '/exhibitors'))
    apiStore.navigationVisibilities.showExhibitorsLink = response.data.has_external_entities
    response = await callApi(apiStore.buildUrl('/events/event_has_session_materials/' + event.id))
    apiStore.navigationVisibilities.showMaterialsLink = response.data.has_session_materials
    if (apiStore.navigationVisibilities.showMaterialsLink && !apiStore.isStaff) {
        if (event.visible_date) {
            apiStore.navigationVisibilities.showMaterialsLink = dayjs() >= dayjs(event.visible_date) && apiStore.isRegisteredForCurrentEvent
        }
    }
    response = await callApi(apiStore.buildUrl('/events/event_has_external_entities/' + event.id + '/partners'))
    apiStore.navigationVisibilities.showPartnersLink = response.data.has_external_entities
    if (apiStore.presenters && 0 < apiStore.presenters.length) {
        apiStore.navigationVisibilities.showPresentersLink = true
    } else {
        const response = await callApi(apiStore.buildUrl('/events/event_has_published_presenters/' + event.id))
        apiStore.navigationVisibilities.showPresentersLink = response.data.has_published_presenters
    }
    if (apiStore.isStaff) {
        apiStore.navigationVisibilities.showScheduleLink = true
    } else {
        const response = await callApi(apiStore.buildUrl('/events/event_has_published_sessions/' + event.id))
        apiStore.navigationVisibilities.showScheduleLink = response.data.has_published_sessions
    }
    apiStore.navigationVisibilities.showMyScheduleLink = apiStore.navigationVisibilities.showScheduleLink &&
        event.personal_schedules && apiStore.currentAttendee && apiStore.isRegisteredForCurrentEvent
    response = await callApi(apiStore.buildUrl('/events/event_has_external_entities/' + event.id + '/sponsors'))
    apiStore.navigationVisibilities.showSponsorsLink = response.data.has_external_entities
    if ('virtual' == event.format) {
        apiStore.navigationVisibilities.showVenuesLink = false
    } else {
        const response = await callApi(apiStore.buildUrl('/events/venues/?event=' + event.id))
        const venues = response.data
        apiStore.navigationVisibilities.showVenuesLink = Array.isArray(venues) && 0 < venues.length
    }
    if(apiStore.currentEvent.event.poster && apiStore.currentEvent.event.poster.length){
        apiStore.navigationVisibilities.showPosterLink = true
    } else {
        apiStore.navigationVisibilities.showPosterLink = false
    }

    apiStore.navigationVisibilities.isVisibilitySet = true
    console.log('Navigation visibility set')

}

export const setRegistrationStatus = async function(apiStore) {
    apiStore.isPaidForCurrentEvent = false
    apiStore.isRegisteredForCurrentEvent = false
    apiStore.isWaitListedForCurrentEvent = false

    let response = await callApi(apiStore.buildUrl('/events/attendees/?event=' + apiStore.currentEvent.event.id + '&a=' + apiStore.oid))
    if (response.data && Array.isArray(response.data) && 0 < response.data.length) {
        apiStore.isRegisteredForCurrentEvent = true
        const eventAttendee = response.data[0]
        if (false == eventAttendee.is_payment_required || true == eventAttendee.is_paid) {
            apiStore.isPaidForCurrentEvent = true
        }
    }

    response = await callApi(apiStore.buildUrl('/events/waitlists/?event=' + apiStore.currentEvent.event.id))
    if (Array.isArray(response.data) && 0 < response.data.length) {
        for (let i in response.data) {
            for (let j in response.data[i].attendees) {
                if (apiStore.currentAttendee.id == response.data[i].attendees[j].id) {
                    apiStore.isWaitListedForCurrentEvent = true
                    break
                }
            }
        }
    }
}